import { garageHeaders, logoutGarage } from "./garageAuth";

export const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api";

/**
 * Shared request helper for every garage-scoped module (customers, bookings,
 * work orders, quotations, invoices, mechanics, dashboard, reports).
 * - attaches the garage bearer token (not the superadmin token — see ./garageAuth)
 * - builds the query string (skips empty values)
 * - throws Error(server message) on non-2xx
 * - on 401 clears the garage token and fires "garage-unauthorized" so the UI
 *   returns to the garage login, without touching any superadmin session
 */
export async function request(path, { method = "GET", params, body, signal } = {}) {
  const qs = new URLSearchParams();
  Object.entries(params || {}).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "") qs.append(k, v);
  });

  const response = await fetch(`${API_URL}${path}${qs.toString() ? `?${qs}` : ""}`, {
    method,
    signal,
    headers: {
      ...garageHeaders(),
      ...(body !== undefined ? { "Content-Type": "application/json" } : {}),
    },
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });

  if (response.status === 401) {
    logoutGarage();
    window.dispatchEvent(new Event("garage-unauthorized"));
  }
  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data.message || `Request failed: ${response.statusText}`);
  }
  if (response.status === 204) return null;
  return response.json().catch(() => null);
}